import { render, staticRenderFns } from "./IdentificacaoList.vue?vue&type=template&id=8c544cb2"
import script from "./IdentificacaoList.vue?vue&type=script&lang=js"
export * from "./IdentificacaoList.vue?vue&type=script&lang=js"
import style0 from "./IdentificacaoList.vue?vue&type=style&index=0&id=8c544cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports